import { Typography } from '@mui/material';
import type { Currency } from '@weft/types';
import { isNotEmptyString } from '@weft/utils';
import React from 'react';
import { Price } from '../../../../../../../../components/design/Price';

type PerUnitItemProps = {
  name: string;
  description?: string;
  pricePerUnit: number;
  chunkSize: number;
  currency: Currency;
};

export const PerUnitItem: React.FC<PerUnitItemProps> = ({ chunkSize, name, description, pricePerUnit, currency }) => {
  return (
    <section className="flex justify-between">
      <div className="flex flex-col justify-center gap-y-1">
        <p className="text-lg font-medium text-black">{name}</p>
        {isNotEmptyString(description) && (
          <p className="text-[15px] font-normal text-[#6F6F6F]">
            {description}
          </p>
        )}
      </div>
      <div className='flex gap-20'>
        {chunkSize > 1 && (
          <div className="flex flex-col gap-y-1 text-center">
            <p className="text-sm font-normal text-[#A3ACBD]">Bulk size</p>
            <Typography fontSize={14}>
              {chunkSize}
            </Typography>
          </div>
        )}
        <div className="flex flex-col gap-y-1 text-end">
          <p className="text-sm font-normal text-[#A3ACBD]">{chunkSize === 1 ? 'Price Per Unit' : 'Price Per Bulk'}</p>
          <Price
            currency={currency}
            align="right"
            className="text-xl font-medium text-black"
          >
            {pricePerUnit}
          </Price>
        </div>
      </div>
    </section>
  );
};